import { CustomColumn } from '../../../../types/customColumn';

export const saleTaxCreditColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  
  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;
      return (
        <div className="text-sm leading-6">
          {/* Código del producto */}
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>
          {/* Nombre */}
          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>
          {/* Categoría (misma caja/clases, ahora en dos líneas) */}
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },

  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unit } = row.original;
      return (
        <div className="text-sm leading-6">
          {Number(quantity).toFixed(2)} {unit || ''}
        </div>
      );
    },
  },
  {
    Header: 'P.U. Neto', // ✅ Precio unitario neto
    accessor: 'netUnitPrice',
    customCell: ({ row }) => {
      const { netUnitPrice } = row.original;
      return (
        <div className="text-sm leading-6">
          ${Number(netUnitPrice).toFixed(2)}
        </div>
      );
    },
  },
  {
    Header: 'Descuento',
    accessor: 'discount',
    customCell: ({ value }) =>
      value ? (
        <div className="text-red-600 text-sm leading-6">
          -${Number(value).toFixed(2)}
        </div>
      ) : (
        <div className="text-sm leading-6">$0.00</div>
      ),
  },
  {
    Header: 'IVA',
    accessor: 'vat',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value).toFixed(2)}</div>
    ),
  },
  {
    Header: 'Total Neto', // ✅ Cambiamos el encabezado para mayor claridad
    accessor: 'taxedAmount', // ✅ Ahora usamos el campo sin IVA
    customCell: ({ row }) => {
      const { taxedAmount } = row.original;
      return (
        <div className="text-sm font-medium leading-6">
          ${Number(taxedAmount).toFixed(2)}
        </div>
      );
    },
  },
];
